import Image from "next/image";
import { IoBed } from "react-icons/io5";
import { RiPencilRuler2Fill } from "react-icons/ri";
import { TbBathFilled } from "react-icons/tb";
import styles from "./chat-bubble.module.css";
import { MessageListingCard } from "../../../../../../../lib/chat-store/types";
import { useLocale } from "next-intl";
import { makeLocalizedHrefNoLocale } from "@/lib/localizedRoutes/routeHelpers";
import { getMedia } from "@/lib/media/shared";

export default function ListingCard({
  listing,
  index,
  total,
  selectable = false,
  selected = false,
  theme = "dark",
  onSelect,
  onClick,
}: {
  listing: MessageListingCard;
  index?: number;
  total?: number;

  selectable?: boolean;
  selected?: boolean;
  theme?: "light" | "dark";

  onSelect?: () => void;
  onClick?: () => void;
}) {
  const locale = useLocale();

  const handleCardClick = () => {
    const newUrl = makeLocalizedHrefNoLocale(locale, "listing", [
      listing.listing_id,
    ]);
    window.open(newUrl, "_blank", "noopener,noreferrer");
  };
  const resolvedMedia = getMedia(listing.photo);
  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleCardClick();
      }}
      className={`${styles.listingCard} ${styles[theme]} ${selected ? styles.selected : ""}${
        selectable ? styles.selectable : ""
      }`}
    >
      {total && index && total > 1 && (
        <span className={styles.currentListing}>
          {index} / {total}
        </span>
      )}
      <div className={styles.imageWrapper}>
        <Image
          className={styles.listingImage}
          src={resolvedMedia?.src || "/broken_image.webp"}
          fill
          sizes="260px"
          alt="Listing photo"
        />
      </div>

      <div className={styles.cardContent}>
        <span className={styles.title}>{listing.title}</span>

        <span className={styles.price}>€{listing.price}</span>

        <div className={styles.metaRow}>
          <span className={styles.metaItem}>
            <span className={styles.value}>{listing.number_of_bedrooms}</span>
            <IoBed aria-hidden="true" className={styles.icon} />
          </span>
          <span className={styles.metaItem}>
            <span className={styles.value}>{listing.number_of_bathrooms}</span>
            <TbBathFilled aria-hidden="true" className={styles.icon} />
          </span>
          <span className={styles.metaItem}>
            <span className={styles.value}>
              {listing.interior_space || listing.lot_size}
            </span>
            <RiPencilRuler2Fill aria-hidden="true" className={styles.icon} />
          </span>
        </div>
      </div>
    </div>
  );
}
